import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { CheckCircle2, Loader2, ShieldCheck, XCircle } from 'lucide-react';
import { toast } from 'sonner';
import { useConfirmarPagoMock } from '@/features/pagos/api';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { Button } from '@/components/ui/button';

export function MockCheckoutRoute() {
  const { pagoId } = useParams();
  const navigate = useNavigate();
  const { condoId } = useCondoContext();
  const [processing, setProcessing] = useState(false);
  const mutation = useConfirmarPagoMock();

  async function confirmar(outcome: 'aprobado' | 'rechazado') {
    if (!pagoId) return;
    setProcessing(true);
    try {
      await mutation.mutateAsync({ pagoId, outcome });
      if (outcome === 'aprobado') {
        toast.success('Pago confirmado', {
          description: 'Gracias por tu pago. El estado de tu cargo se actualizo.',
        });
      } else {
        toast.error('Pago rechazado (mock)');
      }
      navigate(`/app/condominios/${condoId}/mis-cargos`);
    } finally {
      setProcessing(false);
    }
  }

  return (
    <div className="grid min-h-[calc(100vh-4rem)] place-items-center px-6 py-10">
      <div className="relative w-full max-w-md overflow-hidden rounded-md border border-[var(--color-hairline)] bg-[var(--color-paper)] p-10 text-center">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 opacity-60"
          style={{
            backgroundImage:
              'radial-gradient(circle at 50% 0%, color-mix(in oklch, var(--color-primary) 8%, transparent), transparent 60%)',
          }}
        />
        <div className="relative z-10">
          <div className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-[var(--color-primary-50)] text-[var(--color-primary)]">
            <ShieldCheck className="h-7 w-7" />
          </div>
          <p className="eyebrow mt-6">Pasarela mock</p>
          <h1 className="font-display-tight mt-2 text-3xl font-semibold tracking-tight">
            Confirma tu pago
          </h1>
          <p className="mt-3 text-sm text-[var(--color-ink-muted)]">
            Esta es una pantalla simulada del proveedor de pagos. En produccion
            seras redirigido a Khipu o WebPay.
          </p>
          <p className="mt-6 font-mono text-[0.6875rem] text-[var(--color-ink-faint)]">
            Ref: {pagoId?.slice(-12)}
          </p>

          <div className="mt-8 flex flex-col gap-2">
            <Button
              size="lg"
              onClick={() => confirmar('aprobado')}
              disabled={processing}
            >
              {processing ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <CheckCircle2 className="h-4 w-4" />
              )}
              Confirmar pago
            </Button>
            <Button
              variant="outline"
              onClick={() => confirmar('rechazado')}
              disabled={processing}
            >
              <XCircle className="h-4 w-4" />
              Simular rechazo
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
